import { mttStagingTableParser } from './utils/mttStagingTableInboundUtils';
export const UPDATE_MTT_STAGING_TABLE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'mttStagingTable', parser: mttStagingTableParser }]
};
